import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";

export default function Footer({ content }) {
  const { t } = useLang();
  return (
    <footer className="bg-black text-white/70" data-testid="site-footer">
      <div className="afb-container py-10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs">
        <div className="flex items-center gap-3">
          <span className="inline-block w-6 h-[1px] bg-afb-gold" />
          <span className="serif text-base text-white">
            Agenzia Funebre <span className="text-afb-gold">Barone</span>
          </span>
        </div>
        <p className="text-center">{t("footer.tagline")}</p>
        <div className="flex items-center gap-3">
          <span>
            © {new Date().getFullYear()} {t("footer.rights")}
          </span>
          <span aria-hidden="true" className="text-white/30">·</span>
          <Link
            to="/admin"
            className="text-white/30 hover:text-afb-gold transition-colors"
            data-testid="footer-admin-link"
            title="Area riservata"
          >
            Admin
          </Link>
          {/* keep content prop wired so editor knows footer can grow */}
          <span className="sr-only">{content?.email}</span>
        </div>
      </div>
    </footer>
  );
}
